import type React from 'react'

import type { MenuRecipeGeneralTag, StandardRecipeItem } from '@library/api-menu-experience'

export const formatSurchargeLabel = (label?: string) => {
  if (!label) {
    return null
  }

  if (/per portion|a portion/i.test(label)) {
    return label
  }

  return `${label} per portion`
}

type RecipeTileState = {
  isOutOfStock?: boolean
}

export const getRecipeTileGeneralTags = (recipe: StandardRecipeItem): MenuRecipeGeneralTag[] => {
  const generalTags = recipe.tagGroups.general ?? []

  return generalTags.filter((tag) => tag.type !== 'soldOut')
}

const getRenderedBannerText = (recipe: StandardRecipeItem) => {
  const banner = recipe.tagGroups.banner

  if (recipe.displayType !== 'ready-to-heat' || !banner) {
    return []
  }

  return banner.tags.map((tag) => tag.text)
}

export const getRecipeTileAriaLabel = (
  recipe: StandardRecipeItem,
  { isOutOfStock = false }: RecipeTileState = {},
) =>
  [
    isOutOfStock ? 'Sold Out' : undefined,
    recipe.title,
    ...(recipe.tagGroups.dietary ?? []).map((tag) => tag.accessibleText),
    ...getRecipeTileGeneralTags(recipe).map((tag) => tag.text),
    ...(recipe.tagGroups.subtitle ?? []).map((tag) => tag.accessibleText),
    ...getRenderedBannerText(recipe),
    recipe.customisations?.label,
    !isOutOfStock ? formatSurchargeLabel(recipe.pricing?.perPortionSurcharge) : undefined,
  ]
    .filter(Boolean)
    .join('. ')

export const onSpaceOrEnter =
  (callback: (event: React.KeyboardEvent) => void) => (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      callback(event)
    }
  }
